var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',[_c('v-tab',{on:{"click":function($event){return _vm.seleccion(0)}}},[_vm._v("Ensayos")]),_c('v-tab',{on:{"click":function($event){return _vm.seleccion(1)}}},[_vm._v("HMI")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }